export default "__VITE_ASSET__EVIteVQW__"